/* @flow strict */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';
import IntegrationsCardsEmbed from './embed';
import IntegrationsCardsOrder from './eventOrder';
import IntegrationsCalendarPreviewModal from './previewModal';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  }
};

const items = [
  {
    link: '',
    label: 'Embed'
  },
  {
    link: 'order',
    label: 'Event order'
  }
];

const IntegrationsCards = ({ match }: PropsType): React.Element<'div'> => {
  const { params: { viewTab } } = match;
  const _viewTab = viewTab ? viewTab.toLowerCase() : '';
  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`IntegrationsCards-menuItems-${k}`}
        className={`${(_viewTab) === i.link ? 'active' : ''}`}
      >
        <Link to={`/integrations/cards/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });
  const [isOpenPreview, handleTogglePreviewModal] = React.useState(false);

  return (
    <div className='IntegrationsCards'>
      <NavbarTitleBackAction />

      <div className="sparxo-router-content">
        <div className="sparxo-page-container">
          <div className="event-list">
            <div className="facebook-page">
              <div className="sparxo-integrations-cards">
                <div className="sparxo-integrations-list" style={{ marginTop: 0 }}>
                  <div
                    className="sparxo-integrations-item"
                    style={{
                      background: 'none',
                      maxWidth: '360px',
                      margin: '0 auto'
                    }}
                  >
                    <div className="media">
                      <div className="media-left">
                        <img src="https://nest.sparxo.com/public/integrations/code.png" alt="cards" className="media-object"/>
                      </div>

                      <div className="media-body">
                        <h4 className="media-heading" style={{ fontWeight: 0 }}>
                          Sparxo Card View
                        </h4>

                        <span>Add Sparxo Calendar to your website</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-center" style={{ marginBottom: '20px' }}>
                 Sell tickets directly on your site by integrating Sparxo Calendar
              </p>

              <div className="panel panel-default panel-page">
                <div className="navbar-page-toolbar customers-navbar code-navbar">
                  <div className="container-fluid" style={{ height: '50px' }}>
                    <ul className="nav">
                      {menuItems}
                    </ul>
                  </div>
                </div>

                {viewTab === 'order' ?
                  <IntegrationsCardsOrder /> : null
                }

              </div>

              {!viewTab ?
                <IntegrationsCardsEmbed
                  handleTogglePreviewModal={handleTogglePreviewModal}
                /> : null
              }
            </div>
          </div>
        </div>
      </div>

      {isOpenPreview ?
        <IntegrationsCalendarPreviewModal
          isOpen={isOpenPreview}
          handleToggleModal={handleTogglePreviewModal}
        /> : null}
    </div>
  );
};

export default withRouter(IntegrationsCards);
